export default {
  methods: {
    hashFileName(fileName, existingNames = []) {
      const lastDot = fileName.lastIndexOf(".");
      const name = lastDot === -1 ? fileName : fileName.slice(0, lastDot);
      const ext = lastDot === -1 ? "" : fileName.slice(lastDot);
      const base = this.$CryptoJS.MD5(name).toString();

      // BE stores filenames with the last "." replaced by "_" (e.g. "abc123_pdf" = "abc123.pdf").
      // Normalize to dot-separated format so collision detection works for both storage formats.
      const normalizeExt = n => {
        const lastUs = n.lastIndexOf("_");
        const lastDot = n.lastIndexOf(".");
        // Only rewrite when the last separator is _ with no dot after it — this is BE format.
        if (lastUs !== -1 && lastUs > lastDot) {
          return `${n.slice(0, lastUs)}.${n.slice(lastUs + 1)}`;
        }
        return n;
      };
      const taken = new Set(existingNames.map(normalizeExt));

      let candidate = `${base}${ext}`;
      let counter = 1;
      while (taken.has(candidate)) {
        candidate = `${base}_${counter}${ext}`;
        counter++;
      }
      return candidate;
    }
  }
};
